import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-salary-forms-8-25',
    templateUrl: './salary-forms-8-25.component.html',
    styleUrl: './salary-forms-8-25.component.css',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SalaryForms825Component {

}
